import styled from 'styled-components';

import { responsive } from '@/utils';

import { gamepadColors } from './gamePadIllustration.colors.ts';

export const StyledText = styled.text`
  font-family: ${responsive.font.family.label};
  font-size: ${responsive.font.size['4xlarge']};
  font-style: normal;
  font-weight: ${responsive.font.weight.regular};
  line-height: ${responsive.font.line.height['3xlarge']};
  fill: ${gamepadColors.text};
  pointer-events: none;
`;
